import { useLazyQuery } from '@apollo/client';
import { useState, useEffect, useCallback } from 'react';
import { IAddressLight, ISearchAddressResponse } from '../../../types/contact';
import { SEARCH_ADDRESS } from '../../../graphql/contact-gql';
import { IOption } from '../../../types/common';
import Typeahead from './typeahead';
import { join } from '../../../utils/commons';

type AddressTypeaheadProps = {
    id?: string;
    value?: IAddressLight;
    error?: string;
    validate?:(error:string)=>void;
    addressSelected: (address: IAddressLight | undefined) => void;
    onChange?:(event:string) => void
    onBlur?: () => void;
    onInput?: (str:string) => void;
    includeInactive: boolean;
    autoFocus?: boolean;
}

const AddressTypeahead = (props: AddressTypeaheadProps) => {
    const { id, value, error, addressSelected, validate, onChange, onBlur, onInput, includeInactive, autoFocus } = props
    const [addressOpts, setAddressOpts] = useState<IOption[]>([])
    const [selectedAddress, setSelectedAddress] = useState<IOption | undefined>()
    const [searchAddress, { loading, data: addressResp }] = useLazyQuery<ISearchAddressResponse>(SEARCH_ADDRESS)
    const [addressError, setAddressError] = useState<string>('')

    useEffect(() => {
        if (addressResp?.searchAddress && addressResp?.searchAddress.length > 0) {
            setAddressOpts(addressResp.searchAddress.map((e: IAddressLight) => ({id: e.id, label: join(e.addressTxt, e.addressTxt2)})))
        } else {
            setAddressOpts([])
        }
    }, [addressResp])

    useEffect(() => {
        if (value)  {
            setSelectedAddress({id: value.id, label: join(value.addressTxt, value.addressTxt2)})
        } else {
            setSelectedAddress(undefined)
        }
    }, [value])

    useEffect(() => {
        validate && validate(addressError);
    }, [addressError,validate])

    const queryAddress = useCallback((str: string) => {
        onChange && onChange(str)
            searchAddress({
                variables: {
                    q:str,
                    limit:20,
                    includeInactive: includeInactive
                }
            }).then((response)=>{
                if(!response.data?.searchAddress||response.data.searchAddress.length===0)setAddressError("Address does not exist.")
                else setAddressError("")
            })
        
    }, [])

    const selectAddress = useCallback((opt: IOption) => {
        setSelectedAddress(opt)
        let adr = addressResp?.searchAddress.find(e => e.id === opt?.id)
        addressSelected(adr ? adr : undefined)
    }, [addressResp])

    const onClear = () =>{      
        setSelectedAddress(undefined)
        addressSelected(undefined)
        setAddressError("") 
    }

    return (
        <Typeahead
            id={id}
            placeHolder='Start entering an address and a list will appear'
            options={addressOpts}
            value={selectedAddress}
            loading={loading}
            error={error}
            query={queryAddress}
            onSelected={selectAddress}
            onClear={onClear}
            onBlur={onBlur}
            onInput={onInput}
            autoFocus={autoFocus}
        />
    )
}

export default AddressTypeahead
